import { Link } from "react-router-dom";
import { ShieldCheck, Twitter, Github, Linkedin, Facebook, Mail, MapPin } from "lucide-react";

const cols = [
  {
    title: "Ürünler",
    links: [
      { label: "Web Hosting", to: "/hosting" },
      { label: "VPS Sunucu", to: "/sunucular" },
      { label: "Dedicated Sunucu", to: "/sunucular" },
      { label: "Alan Adı", to: "/alan-adi" },
      { label: "Güvenlik", to: "/guvenlik" },
    ],
  },
  {
    title: "Kurumsal",
    links: [
      { label: "Hakkımızda", to: "/hakkimizda" },
      { label: "Fiyatlandırma", to: "/fiyatlandirma" },
      { label: "İletişim", to: "/iletisim" },
      { label: "Giriş Yap", to: "/giris" },
    ],
  },
  {
    title: "Kaynaklar",
    links: [
      { label: "Dokümantasyon", to: "/iletisim" },
      { label: "Yardım Merkezi", to: "/iletisim" },
      { label: "Sistem Durumu", to: "/" },
      { label: "Destek", to: "/iletisim" },
    ],
  },
];

export const Footer = () => {
  return (
    <footer data-testid="main-footer" className="relative mt-24 border-t border-white/5 bg-[#07080C]">
      <div className="absolute inset-0 radial-glow-blue opacity-40 pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 py-20">
        <div className="mb-20 rounded-3xl border border-white/10 bg-gradient-to-br from-[#0F1220] to-[#0A0B10] p-10 lg:p-14 overflow-hidden relative">
          <div className="absolute -top-20 -right-20 w-96 h-96 bg-blue-600/20 rounded-full blur-3xl" />
          <div className="relative flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-blue-400 mb-3">Görüşelim</p>
              <h3 className="font-heading text-3xl sm:text-4xl font-semibold tracking-tight max-w-xl">
                Daha hızlı ve güvenli yayına hazır mısınız?
              </h3>
            </div>
            <Link
              to="/iletisim"
              data-testid="footer-cta-contact"
              className="btn-shine inline-flex items-center gap-2 rounded-full bg-blue-600 hover:bg-blue-500 px-7 py-4 text-sm font-semibold text-white shadow-[0_0_30px_rgba(0,122,255,0.3)] transition-all"
            >
              Projeyi Başlat
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-6 gap-10">
          <div className="col-span-2 md:col-span-3">
            <Link to="/" className="flex items-center gap-2 mb-5">
              <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-blue-500 to-blue-700 flex items-center justify-center">
                <ShieldCheck size={20} strokeWidth={2.2} />
              </div>
              <span className="font-heading font-bold text-xl tracking-tight">
                DR <span className="text-blue-500">SOFT</span>
              </span>
            </Link>
            <p className="text-zinc-400 text-sm leading-relaxed max-w-sm mb-6">
              Web hosting, sanal sunucular ve akıllı güvenlik duvarı — performans ve güvenlikten
              ödün vermeyen ekipler için tasarlandı.
            </p>
            <div className="flex items-center gap-3 text-zinc-400 text-sm mb-2">
              <Mail size={15} className="text-blue-400" />
              <span>destek@drsoft.com.tr</span>
            </div>
            <div className="flex items-center gap-3 text-zinc-400 text-sm">
              <MapPin size={15} className="text-blue-400" />
              <span>İstanbul · Ankara · Amsterdam</span>
            </div>
          </div>

          {cols.map((col) => (
            <div key={col.title}>
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500 mb-5">{col.title}</p>
              <ul className="space-y-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      data-testid={`footer-link-${link.label.toLowerCase().replace(/[çğıöşü]/g, (c) => ({ç:'c',ğ:'g',ı:'i',ö:'o',ş:'s',ü:'u'}[c])).replace(/[^a-z0-9]+/g, '-')}`}
                      className="text-zinc-400 hover:text-white text-sm transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <p className="text-zinc-500 text-sm">
            © {new Date().getFullYear()} DR SOFT Hosting. Tüm hakları saklıdır.
          </p>
          <div className="flex items-center gap-2">
            {[
              { icon: Twitter, label: "twitter" },
              { icon: Github, label: "github" },
              { icon: Linkedin, label: "linkedin" },
              { icon: Facebook, label: "facebook" },
            ].map(({ icon: Icon, label }) => (
              <a
                key={label}
                href="#"
                onClick={(e) => e.preventDefault()}
                data-testid={`footer-social-${label}`}
                aria-label={label}
                className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-zinc-400 hover:text-white hover:border-blue-500/50 hover:bg-blue-500/10 transition-all"
              >
                <Icon size={16} />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
